import React, { useState } from 'react';

const CardCvc = ({ placeholder, error, name, width, value, margin, icon, max, comment, setValue, submitCount }) => {
	const [isFocused, setIsFocused] = useState(false);
	const [isVisible, setIsVisible] = useState(false);

	return (
		<div
			className="input-container"
			style={{
				width: width == 'full' ? '100%' : `calc(${width == 'half' ? 50 : width}% - 6px)`,
				marginRight: margin ? '12px' : '0px',
				backgroundColor: 'transparent',
			}}
		>
			<div className={`input input--text ${error && 'input--error'}`}>
				<input
					maxLength={max}
					type="number"
					autoComplete="cc-csc"
					className="styledInput"
					name={name}
					value={value}
					onFocus={() => {
						setIsFocused(true);
					}}
					onChange={(e) => {
						if (e.target?.value?.length > 4) {
							return;
						} else {
							setValue(name, e.target.value, { shouldValidate: submitCount > 0 && true, shouldTouch: true });
						}
					}}
					onBlur={() => {
						setIsFocused(false);
					}}
				/>
				<label className={isFocused || value?.length > 0 ? 'styledLabel styledLabel--active' : 'styledLabel'}>
					{placeholder}
				</label>

				{icon && (
					<div
						className="input__helper"
						onClick={() => {
							if (window.isMobile) {
								setIsVisible(!isVisible);
							}
						}}
					>
						<div
							className="input__img--alt"
							style={{
								backgroundImage: `url(${icon}`,
							}}
						/>

						{comment && (
							<span className="input__comment" visible={isVisible.toString()}>
								{comment}
							</span>
						)}
					</div>
				)}
			</div>
			{error && <span className="formError">{error}</span>}
		</div>
	);
};

export default CardCvc;
